import React from "react";
import { observer, inject } from "mobx-react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { DocumentPageHeader } from "../../../../components/DocumentPageHeader";
import { STORE_CREATE_EDIT_CUSTOMER_ORDER, STORE_COMMON, STORE_CUSTOMERS, STORE_AUTH, STORE_VIN_QUERIES } from "../../../../constants";
import { CreateEditCustomerOrderStore, CreateOrderPosition, Part, Customer, CustomersStore, AuthStore, CreateOrderCdekSettings, VinQueriesStore, VinQueryDetails, CommonStore } from "../../../../stores";
import { AddPositionModal } from "./AddPositionModal";
import { SelectCustomerModal } from "../../../../components/SelectCustomerModal";
import { RouteComponentProps } from "react-router";
import { NotificationLevel } from "../../../../stores/NotificationStore";
import { FormComponent } from "./Components/FormComponent";
import { ProductsTableComponent } from "./Components/ProductsTableComponent";
import { NewCustomerModal } from "./NewCustomerModal";
import { ConfirmationModal } from "./Components/ConfirmationModal";
import { SOURCES_AS61, SOURCES_AB61 } from "../../../../constants/sources";
import { MobileViewModal } from "./Components/MobileViewModal";
import { AddRussianCarPositionModal } from "./AddRussianCarPositionModal";
import { CdekFormModal } from "./Components/CdekFormModal";
import { v4 as uuidv4 } from 'uuid';



interface IProps {
    [STORE_CREATE_EDIT_CUSTOMER_ORDER]: CreateEditCustomerOrderStore;
    [STORE_CUSTOMERS]: CustomersStore;
    [STORE_VIN_QUERIES]: VinQueriesStore;
    [STORE_COMMON]: CommonStore;
}

interface IState {
    source: string;
    addPositionModalOpened: boolean;
    addRussianCarPositionModalOpened: boolean;
    selectCustomerModalOpened: boolean;
    newCustomerModalOpened: boolean;
    confirmModalOpened: boolean;
    mobileViewModalOpened: boolean;
    cdekFormModalOpened: boolean;

    addPositionForVinPositionId?: number;
    positions: CreateOrderPosition[];
    selectedCustomerName: string;
    customerId: string;
    deliveryPointId: number;
    managerName: string;
    managerComment: string;
    commentForClient: string;
    orderNumber: string;
    orderDate: string;
    customers: any[];
    allCustomers: any[];
    deliveryType: "delivery" | "pickup";
    paymentType: "Cache" | "Cacheless" | "ByReceipt";
    isUrgent: boolean;
    hideCommercialFields: boolean;
    formUniqueKey: number;
    confirmOrder: boolean;
    sendPaymentLink: boolean;
    deliveryOverCdek: boolean;
    customerManagerName: string;
    customerManagerPhone: string;

    cdekToAddress: boolean;
    cdekAddress?: string;
    cdekSettings?: CreateOrderCdekSettings;
    vinQuery?: VinQueryDetails;
    hasChanges: boolean;

}


type Props = IProps & RouteComponentProps<{ draftOrderId: string, vinId: string }>;

@inject(STORE_COMMON, STORE_CREATE_EDIT_CUSTOMER_ORDER, STORE_CUSTOMERS, STORE_AUTH, STORE_VIN_QUERIES)
@observer
export class NewCustomerOrderPage extends React.Component<Props, IState> {
    constructor(props: any) {
        super(props);
        this.state = {
            source: SOURCES_AS61,
            addPositionModalOpened: false,
            addRussianCarPositionModalOpened: false,
            selectCustomerModalOpened: false,
            newCustomerModalOpened: false,
            confirmModalOpened: false,
            mobileViewModalOpened: false,
            cdekFormModalOpened: false,

            positions: [],
            customerId: "",
            selectedCustomerName: "",
            deliveryPointId: -1,
            managerName: "",
            managerComment: "",
            commentForClient: "",
            orderNumber: "",
            orderDate: "",
            customers: [],
            allCustomers: [],
            deliveryType: "delivery",
            paymentType: "Cacheless",
            isUrgent: false,
            hideCommercialFields: false,
            formUniqueKey: new Date().getTime(),
            confirmOrder: false,
            sendPaymentLink: false,
            deliveryOverCdek: false,
            customerManagerName: "",
            customerManagerPhone: "",

            cdekToAddress: false,
            vinQuery: undefined,
            hasChanges: false,
        }

    }
    private createEditStore = (this.props as any)[STORE_CREATE_EDIT_CUSTOMER_ORDER] as CreateEditCustomerOrderStore;
    private customersStore = (this.props as any)[STORE_CUSTOMERS] as CustomersStore;
    private commonStore = (this.props as any)[STORE_COMMON] as CommonStore;
    private authStore = (this.props as any)[STORE_AUTH] as AuthStore;
    private notificationStore = this.customersStore._rootStore.notificationStore;
    private vinQueriesStore = (this.props as any)[STORE_VIN_QUERIES] as VinQueriesStore;

    private unblockNavigation?: () => void;
    private isSavingBeforeLeave = false;
    private skipNextNavigationBlock = false;

    componentDidMount() {

        // this.createEditStore.loadCustomers((customers: Customer[]) => {
        //     this.setState({
        //         allCustomers: customers
        //     })
        // });

        this.setState({
            vinQuery: undefined
        });

        if (!this.authStore.isCallCentre) {
            this.setState({
                source: "abt",
            })
        }

        const draftOrderId = parseInt(this.props.match.params.draftOrderId) || -1;
        const vinId = parseInt(this.props.match.params.vinId) || -1;
        if (vinId > 0) {
            this.vinQueriesStore.loadVinQueryDetails(vinId, (vinQuery: VinQueryDetails) => {
                this.setState({
                    vinQuery: vinQuery,
                    customerId: vinQuery.customerId,
                    selectedCustomerName: `${vinQuery.customerName} тел.:${vinQuery.customerPhone}`
                });
                console.log(vinQuery);
            });
        }


        if (draftOrderId <= 0 && this.state.source !== SOURCES_AS61)
            this.createEditStore.loadDeliveryPoints(this.state.source);

        if (draftOrderId > -1)
            this.createEditStore.loadDraftOrderDetails(draftOrderId, (customerId: string, customerName: string, managerName: string, deliveryPointId: number, source: string, comment: string, commentForClient: string, customerManagerName: string, customerManagerPhone: string, positions: CreateOrderPosition[], vinQueryId?: number) => {

                this.createEditStore.loadDeliveryPoints(source);

                if (vinQueryId != undefined && vinQueryId > 0)
                    this.vinQueriesStore.loadVinQueryDetails(vinQueryId, (vinQuery: VinQueryDetails) => {
                        this.setState({
                            vinQuery: vinQuery
                        });
                        console.log(vinQuery);
                    });


                positions.forEach(w => {
                    w.isInUpdating = true;

                    this.createEditStore.updatePosition(draftOrderId, w.id, (position: CreateOrderPosition, isNotFound: boolean, remmants: number) => {

                        position.relevancyStatus = "Актуал.";
                        position.notFound = false;
                        position.priceChangedUp = false;
                        position.priceChangedDown = false;
                        position.isNotActually = false;
                        position.awailableCount = remmants;

                        if (position.refundDiscount == null) {
                            position.refundDiscount = 0;
                        }
                        if (position.isAllowDiscountRefund == null) {
                            position.isAllowDiscountRefund = false;
                        }

                        if (!isNotFound) {
                            position.newCostSale = position.costSale;
                            if (position.costSale > w.costSale) {
                                position.relevancyStatus = "Цена повысилась";
                                position.priceChangedUp = true;
                                position.isNotActually = true;
                            }
                            else if (position.costSale < w.costSale) {
                                position.relevancyStatus = "Цена снизилась";
                                position.priceChangedDown = true;
                            }

                            if (position.count > remmants) {
                                position.relevancyStatus = "Нет в наличии";
                                position.notFound = true;
                                position.isNotActually = true;
                            }
                        }
                        else {
                            position.relevancyStatus = "Нет в наличии";
                            position.notFound = true;
                            position.isNotActually = true;
                        }

                        const currentPositions = this.state.positions;

                        const newPositions = currentPositions.map(cp => {
                            if (cp.id === position.id)
                                position.costSale = cp.costSale;
                            return cp.id === position.id ? position : cp;
                        });
                        this.setState({
                            positions: newPositions
                        });


                    });

                });



                this.setState({
                    deliveryPointId: deliveryPointId,
                    customerId: customerId,
                    source: source,
                    selectedCustomerName: customerName,
                    managerName: managerName,
                    managerComment: comment,
                    commentForClient: commentForClient,
                    customerManagerName: customerManagerName,
                    customerManagerPhone: customerManagerPhone,
                    positions: positions,
                    hasChanges: false
                });

            });

        this.unblockNavigation = this.props.history.block((location) => {
            if (this.skipNextNavigationBlock) {
                this.skipNextNavigationBlock = false;
                return;
            }

            if (this.isSavingBeforeLeave) return false;

            if (!this.state.hasChanges) return;

            this.isSavingBeforeLeave = true;
            this.createDraftOrder(location.pathname);

            return false;
        });
    }

    componentWillUnmount() {
        if (this.unblockNavigation) {
            this.unblockNavigation();
        }
    }

    onFormChange = (fieldName: string, value: any) => {
        const self = this as any;
        self.setState(() => ({
            [fieldName]: value,
            hasChanges: true
        }));

    }

    onFormCheckboxChange = (fieldName: string, value: string, checked: boolean) => {
        const self = this as any;
        if (fieldName === "hideCommercialFields")
            self.setState(() => ({
                [fieldName]: checked
            }));

        else if (fieldName === "deliveryOverCdek") {

            self.setState(() => ({
                [fieldName]: checked,
                deliveryPointId: checked ? 140 : this.state.deliveryPointId,
                positions: checked && this.state.deliveryPointId == 140 ? this.state.positions : []
            }));

        } else if (checked) {
            const previousSource = this.state.source;

            if (fieldName === "source") {
                self.setState(() => ({
                    deliveryPointId: -1
                }));

                if (previousSource !== value && value !== SOURCES_AS61)
                    this.createEditStore.loadDeliveryPoints(value);
            }

            self.setState(() => ({
                [fieldName]: value
            }));

        }

    }

    //#region Modals open/close handlers

    openAddPositionModal = (vinPositionId?: number) => {
        if (this.state.customerId === undefined || this.state.customerId === '')
            this.notificationStore.addNotification("Выберите клиента!", NotificationLevel.error);
        else if (this.state.deliveryPointId === -1 && this.state.source === SOURCES_AB61)
            this.notificationStore.addNotification("Выберите точку выдачи!", NotificationLevel.error);
        else
            this.setState({
                addPositionForVinPositionId: vinPositionId,
                addPositionModalOpened: true
            });
    }

    closeAddPositionModal = () => {
        this.setState({
            addPositionModalOpened: false
        });
    }
    openAddRussianCarPositionModal = () => {
        if (this.state.customerId === undefined || this.state.customerId === '')
            this.notificationStore.addNotification("Выберите клиента!", NotificationLevel.error);
        else if (this.state.deliveryPointId === -1 && this.state.source === SOURCES_AB61)
            this.notificationStore.addNotification("Выберите точку выдачи!", NotificationLevel.error);
        else
            this.setState({
                addPositionModalOpened: true
            });
    }
    closeAddRussianCarPositionModal = () => {
        this.setState({
            addRussianCarPositionModalOpened: false
        });
    }
    openSelectCustomerModal = () => {
        this.setState({
            selectCustomerModalOpened: true
        });
    }

    closeSelectCustomerModal = () => {
        this.setState({
            selectCustomerModalOpened: false
        });
    }
    openNewCustomerModal = () => {
        this.setState({
            newCustomerModalOpened: true
        });
    }

    closeNewCustomerModal = () => {
        this.setState({
            newCustomerModalOpened: false
        });
    }
    openMobileViewModal = () => {
        this.setState({
            mobileViewModalOpened: true
        });
    }

    closeMobileViewModal = () => {
        this.setState({
            mobileViewModalOpened: false
        });
    }
    //#endregion

    addPositionToOrder = (part: Part, count: number) => {
        // if(part.count)
        const positions = this.state.positions;
        let changed = false;
        positions.forEach(item => {
            if (item.article === part.article
                && item.brand === part.brand
                && item.supCode === part.supCode
                && item.supNameForOrder === part.supNameForOrder
            ) {
                changed = true;
                item.count += count;
            }
        });
        if (!changed) {
            const maxSorting = positions.length == 0 ? 0 : Math.max(...positions.map(item => item.sorting));
            positions.push({
                sorting: maxSorting + 1,
                uuid: uuidv4(),
                vinQueryPositionId: this.state.addPositionForVinPositionId,
                id: -1,
                article: part.article,
                brand: part.brand,
                description: part.description,
                costSale: part.cost,
                newCostSale: part.cost,
                awailableCount: part.count,
                count: count,
                supCode: part.supCode,
                supName: part.supName,
                supNameForOrder: part.supNameForOrder,
                supTimeMin: part.supTimeMin,
                supTimeMax: part.supTimeMax,
                deliveryTimeString: part.deliveryTimeString,
                isInUpdating: false,
                relevancyStatus: "Актуал.",
                notFound: false,
                priceChangedDown: false,
                priceChangedUp: false,
                isNotActually: false,
                isChecked: true,
                comment: "",
                isAllowDiscountRefund: part.isAllowDiscountRefund,
                refundDiscount: part.refundDiscount,
                branchSort: part.branchSort,
                hasBranchParts: part.hasBranchParts,
                timeToRegionMin: part.timeToRegionMin,
                timeToRegionMax: part.timeToRegionMax,
                timeToRegionString: part.timeToRegionString
            })
        }

        this.setState({
            positions: positions,
            hasChanges: true
        })
    }



    removePosition = (uuid: string) => {
        if (window.confirm("Вы хотите удалить позицию. Продолжить?")) {

            const positions = this.state.positions
                .filter(w => w.uuid != uuid)
                .sort((a, b) => a.sorting > b.sorting ? 1 : -1)
                .map((w, index) => { w.sorting = index + 1; return w; });

            this.setState({
                positions: positions,
                hasChanges: true
            })
        }
    }

    confirmOrder = () => {
        const selectedPositions = this.state.positions.filter(w => w.isChecked);

        if (selectedPositions.length === 0)
            this.notificationStore.addNotification("Не выбрано ни одной строки!", NotificationLevel.error);
        else if (this.state.deliveryPointId === -1 && this.state.source === "ab")
            this.notificationStore.addNotification("Не выбрана точка выдачи!", NotificationLevel.error);
        else if (selectedPositions.filter(w => w.isInUpdating).length > 0)
            this.notificationStore.addNotification("Актуальность позиций проверяется. Дождитесь окончания проверки!", NotificationLevel.error);
        else if (selectedPositions.filter(w => w.awailableCount < w.count).length > 0)
            this.notificationStore.addNotification("В заказе есть позиции с количеством, превышающим доступное. Измените количество!", NotificationLevel.error);
        else if (selectedPositions.filter(w => w.isNotActually).length > 0 && selectedPositions.filter(w => w.notFound).length > 0)
            this.notificationStore.addNotification("Позиция неактуальна. Удалите и добавьте заново!", NotificationLevel.error);
        else if (selectedPositions.filter(w => w.isNotActually).length > 0 && selectedPositions.filter(w => w.notFound).length <= 0) {
            if (window.confirm("Цена позиции увеличена. Оформить заказ с новой ценой?"))
                this.setState({
                    confirmModalOpened: true
                })
        }
        else {
            this.setState({
                confirmModalOpened: true
            })
        }
    }
    createOrder = () => {
        const selectedPositions = this.state.positions.filter(w => w.isChecked).map(w => Object.assign({}, w, { costSale: w.newCostSale }));

        const draftOrderId = parseInt(this.props.match.params.draftOrderId) || -1;

        //Validate cdek
        if (this.state.deliveryOverCdek) {


            const settings = this.state.cdekSettings;
            if (settings == undefined) {
                this.createEditStore._rootStore.commonStore.notifyError("Настройки доставки не заданы");
                return;
            } else {
                if (settings.toAddress) {
                    if (settings.street == undefined || settings.street.length <= 0 || settings.building == null || settings.building.length <= 0) {
                        this.createEditStore._rootStore.commonStore.notifyError("Адрес доставки не указан");
                        return;
                    }
                } else {
                    if (settings.terminalCode == undefined || settings.terminalCode.length <= 0) {
                        this.createEditStore._rootStore.commonStore.notifyError("Не указан терминал доставки");
                        return;
                    }
                }

            }
        }



        this.createEditStore.createOrder(this.state.formUniqueKey, selectedPositions,
            this.state.customerId,
            this.state.source,
            this.state.deliveryType,
            this.state.paymentType,
            this.state.isUrgent,
            this.state.deliveryPointId,
            this.state.managerComment,
            this.state.commentForClient,
            this.state.confirmOrder,
            this.state.sendPaymentLink,
            this.state.cdekSettings,
            (unsuccessedPositions: string[] = []) => {

                const orderedPositions = this.state.positions.filter(w => w.isChecked && unsuccessedPositions.findIndex(f => f == w.uuid) == -1)

                if (orderedPositions.length === this.state.positions.length) {
                    this.setState(
                        {
                            hasChanges: false
                        },
                        () => {
                            this.skipNextNavigationBlock = true;
                            this.props.history.push("/sales/customerorders");
                        }
                    );
                }
                else {
                    const newPositions = this.state.positions.filter(w => !w.isChecked || unsuccessedPositions.findIndex(f => f == w.uuid) >= 0);
                    this.setState({
                        positions: newPositions,
                        confirmModalOpened: false,
                        isUrgent: false,
                        deliveryType: "delivery",
                        paymentType: "Cacheless",
                        hasChanges: true
                    });
                }
            }, false,
            draftOrderId > 0 ? draftOrderId : undefined,
            undefined, // vinQueryId
            this.state.customerManagerName,
            this.state.customerManagerPhone
        );
    }


    createDraftOrder = (redirectTo?: string, forceSave: boolean = false) => {
        if (!forceSave && !this.state.hasChanges) {
            this.skipNextNavigationBlock = true;
            this.props.history.push(redirectTo || "/sales/draftorders");
            return;
        }

        const draftOrderId = parseInt(this.props.match.params.draftOrderId) || -1;

        this.createEditStore.createOrder(
            this.state.formUniqueKey,
            this.state.positions,
            this.state.customerId,
            this.state.source,
            "delivery",
            "Cacheless",
            false,
            this.state.deliveryPointId,
            this.state.managerComment,
            this.state.commentForClient,
            false,
            false,
            undefined,
            () => {
                this.isSavingBeforeLeave = false;

                this.setState({ hasChanges: false }, () => {
                    this.skipNextNavigationBlock = true;
                    this.props.history.push(redirectTo || "/sales/draftorders");
                });
            },
            true,
            draftOrderId > 0 ? draftOrderId : undefined,
            this.state.vinQuery != undefined ? this.state.vinQuery.id : undefined,
            this.state.customerManagerName,
            this.state.customerManagerPhone
        );
    }

    private onCustomerSelected = (customer: Customer) => {
        const customerName = customer.name !== undefined ? `${customer.name}, тел.: ${customer.phone}` : `ФИО не указано, тел.: ${customer.phone}`;
        this.setState({
            customerId: customer.id || "",
            selectCustomerModalOpened: false,
            selectedCustomerName: customerName,
            customerManagerName: customer.managerName,
            customerManagerPhone: customer.managerPhone,
            hasChanges: true
        })
    }

    private onPositionChecked = (uuid: string, checked: boolean) => {
        const positions = this.state.positions.map((w, idx) => {
            if (w.uuid === uuid)
                return Object.assign({}, w, { isChecked: checked });
            return w;
        });
        this.setState({
            positions,
            formUniqueKey: new Date().getTime()
        })
    }
    private onAllPositionChecked = (checked: boolean) => {
        const positions = this.state.positions.map((w) => {
            return Object.assign({}, w, { isChecked: checked });
        })
        this.setState({
            positions
        })
    }
    private changePositionCount = (uuid: string, newCount: number) => {
        const positions = this.state.positions.map((w, index) => {
            return Object.assign({}, w, { count: uuid === w.uuid ? newCount : w.count });
        })
        this.setState({
            positions,
            hasChanges: true
        })
    }
    private moveRow = (rowNumber: number, direction: "up" | "down") => {

        if (direction == "up" && rowNumber <= 1) return;
        if (direction == "down" && rowNumber >= this.state.positions.length) return;

        const positions = this.state.positions.map((w, index) => Object.assign({}, w, {}));

        const currentItem = positions[rowNumber - 1];

        if (direction == "up") {
            const prevItem = positions[rowNumber - 2];
            positions[rowNumber - 1] = Object.assign({}, currentItem, { sorting: rowNumber - 1 });
            positions[rowNumber - 2] = Object.assign({}, prevItem, { sorting: rowNumber });
        } else {
            const nextItem = positions[rowNumber];
            positions[rowNumber - 1] = Object.assign({}, currentItem, { sorting: rowNumber + 1 });
            positions[rowNumber] = Object.assign({}, nextItem, { sorting: rowNumber });
        }

        this.setState({
            positions: positions,
            hasChanges: true
        })
    }
    private changeComment = (uuid: string, comment: string) => {
        const positions = this.state.positions.map((w, index) => {
            return Object.assign({}, w, { comment: uuid === w.uuid ? comment : w.comment });
        })
        this.setState({
            positions,
            hasChanges: true
        })
    }
    private setAddressTypeHandler = (deliveryType: "delivery" | "pickup", isUrgent: boolean) => {
        this.setState({
            deliveryType: deliveryType,
            isUrgent: isUrgent
        })
    }
    private setPaymentTypeHandler = (paymentType: "Cache" | "Cacheless" | "ByReceipt") => {
        this.setState({
            paymentType: paymentType
        })
    }
    private changeAbtekaCheckboxesHandler = (confirmOrder: boolean, sendPaymentLink: boolean) => {
        this.setState({
            confirmOrder: confirmOrder,
            sendPaymentLink: sendPaymentLink
        })
    }

    private clearOrder = () => {
        if (window.confirm("Вы хотите очистить заказ! Продолжить?")) {
            this.setState({
                vinQuery: undefined,
                addPositionForVinPositionId: undefined,
                source: SOURCES_AS61,
                addPositionModalOpened: false,
                selectCustomerModalOpened: false,
                newCustomerModalOpened: false,
                confirmModalOpened: false,
                positions: [],
                customerId: "",
                selectedCustomerName: "",
                deliveryPointId: -1,
                managerName: "",
                managerComment: "",
                commentForClient: "",
                orderNumber: "",
                orderDate: "",
                customers: [],
                allCustomers: [],
                deliveryType: "delivery",
                paymentType: "Cacheless",
                isUrgent: false,
                hideCommercialFields: false,
                formUniqueKey: new Date().getTime(),
                confirmOrder: false,
                sendPaymentLink: false,
                hasChanges: false
            }, () => {
                this.props.history.push("/sales/newcustomerorder");
            });
        }
    }

    private setCdekSettings = (receiverCityId: number,
        toAddress: boolean,
        street: string, building: string, appartments: string,
        address: string,
        terminalCode?: string) => {

        this.setState({
            cdekFormModalOpened: false,
            cdekSettings: {
                toAddress,
                receiverCityId,
                terminalCode,
                street,
                building,
                appartments,
                address
            },
            cdekToAddress: toAddress,
            cdekAddress: address
        })

    }

    render() {


        const customerCreatedHandler = (customer: Customer) => {

            const customerName = `${customer.name}, тел.: ${customer.phone}`;
            this.setState((state) => {
                return {
                    customerId: customer.id || "",
                    selectedCustomerName: customerName,
                    newCustomerModalOpened: false,
                    selectCustomerModalOpened: false
                }
            });

        }
        return [<DocumentPageHeader
            saveBtnTitle="Оформить заказ"
            draftBtnTitle="Экспорт Коммерческого предложения"
            header="Заказ покупателя"
            showDraftBtn={true}
            save={this.confirmOrder}
            saveDraft={() => this.createDraftOrder(undefined, true)}
            customerManagerName={this.state.customerManagerName}
            customerManagerPhone={this.state.customerManagerPhone}
            close={() => {
                const draftOrderId = parseInt(this.props.match.params.draftOrderId) || -1;

                if (draftOrderId !== -1)
                    this.skipNextNavigationBlock = true;

                this.createDraftOrder("/sales/draftorders");
            }}
            isDraft={true}
            key="1">
            <Button size="sm" variant="warning" style={{ marginLeft: "10px" }} onClick={this.clearOrder}>Очистить заказ</Button>

        </DocumentPageHeader >,
        <Form key={"2"}>
            <FormComponent
                source={this.state.source}
                customers={this.state.customers}
                managerComment={this.state.managerComment}
                commentForClient={this.state.commentForClient}
                deliveryPointId={this.state.deliveryPointId}
                deliveryPoints={this.createEditStore.deliveryPoints}
                vinQuery={this.state.vinQuery}
                onFormChange={this.onFormChange}
                openMobileViewModal={this.openMobileViewModal}
                onFormCheckboxChange={this.onFormCheckboxChange}
                openCustomerSelector={this.openSelectCustomerModal}
                selectedCustomer={this.state.selectedCustomerName}
                selectedCustomerId={this.state.customerId}
                hideCommercialFields={this.state.hideCommercialFields}
                authStore={this.authStore}
                deliveryOverCdek={this.state.deliveryOverCdek}
                cdekToAddress={this.state.cdekToAddress}
                cdekAddress={this.state.cdekAddress}
                openCdekFormModal={() => { this.setState({ cdekFormModalOpened: true }) }}
            />
            <Row>
                <Col sm={12}>
                    <ProductsTableComponent
                        positions={this.state.positions}
                        vinQuery={this.state.vinQuery}
                        hideCommercialFields={this.state.hideCommercialFields}
                        onPositionChecked={this.onPositionChecked}
                        onAllPositionChecked={this.onAllPositionChecked}
                        openAddPositionModal={this.openAddPositionModal}
                        removePosition={this.removePosition}
                        changePositionCount={this.changePositionCount}
                        changeComment={this.changeComment}
                        moveRow={this.moveRow}
                    />
                </Col>
            </Row>

            <hr />
            <Row>
                <Col md={8}></Col>
                <Col md={4}></Col>
            </Row>
        </Form>
            ,
        <AddPositionModal key={"3"}
            createEditStore={this.createEditStore}
            isOpened={this.state.addPositionModalOpened}
            source={this.state.source}
            onClose={this.closeAddPositionModal}
            addPositionToOrder={this.addPositionToOrder}
            switchToRussianCarsSearch={() => {
                this.setState({
                    addPositionModalOpened: false,
                    addRussianCarPositionModalOpened: true
                })
            }}
            searchByPair={(brand: string, article: string, sortBy: string) => {
                this.createEditStore.searchByPair(brand, article, this.state.customerId, this.state.source, this.state.deliveryPointId, sortBy);
            }} />,

        <SelectCustomerModal
            key={"4"}
            isOpened={this.state.selectCustomerModalOpened}
            customersStore={this.customersStore}
            onHideHandler={this.closeSelectCustomerModal}
            source={this.state.source}
            onCustomerSelected={this.onCustomerSelected}
            openNewCustomerModal={this.openNewCustomerModal}
        />
            ,
        <NewCustomerModal
            key={"5"}
            isOpened={this.state.newCustomerModalOpened}
            customersStore={this.customersStore}
            onHideHandler={this.closeNewCustomerModal}
            source={this.state.source}
            savedCallback={customerCreatedHandler}
        />,
        <ConfirmationModal
            key={"6"}
            source={this.state.source}
            confirmOrder={this.state.confirmOrder}
            sendPaymentLink={this.state.sendPaymentLink}
            isUrgent={this.state.isUrgent}
            deliveryType={this.state.deliveryType}
            paymentType={this.state.paymentType}
            isOpened={this.state.confirmModalOpened}
            positions={this.state.positions.filter(w => w.isChecked)}
            confirmCallback={this.createOrder}
            cancelCallback={() => this.setState({ confirmModalOpened: false })}
            setAddressTypeCallback={this.setAddressTypeHandler}
            setPaymentTypeCallback={this.setPaymentTypeHandler}
            changeAbtekaCheckboxesHandler={this.changeAbtekaCheckboxesHandler}
        />,
        <MobileViewModal
            key={"7"}
            isOpened={this.state.mobileViewModalOpened}
            closeModal={this.closeMobileViewModal}
            positions={this.state.positions}
            notificationStore={this.notificationStore}
            authStore={this.authStore}
            managerName={this.state.managerName}
        />,
        <AddRussianCarPositionModal key={"8"}
            createEditStore={this.createEditStore}
            isOpened={this.state.addRussianCarPositionModalOpened}
            source={this.state.source}
            switchToArticleSearch={() => {
                this.setState({
                    addPositionModalOpened: true,
                    addRussianCarPositionModalOpened: false
                })
            }}
            onClose={this.closeAddRussianCarPositionModal}
            addPositionToOrder={this.addPositionToOrder}
            clientId={this.state.customerId}
        />,
        <CdekFormModal key={"9"}
            isOpened={this.state.cdekFormModalOpened}
            positionsCount={this.state.positions.reduce((a: number, b) => a + b.count, 0)}
            onClose={() => {
                this.setState({ cdekFormModalOpened: false })
            }}
            onSave={this.setCdekSettings}
        />
        ]
    }
}